var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.026,
    height: 39.217,
    viewBox: "0 0 30.026 39.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test-svgrepo-com",
    transform: "translate(-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M84.9,31.049l.028-.037.007-.01a.323.323,0,0,0,.025-.043v-.008c.008-.016.016-.031.022-.047h0c.007-.017.013-.035.019-.052v-.007a.331.331,0,0,1,.013-.053c0-.018,0-.01,0-.016a.135.135,0,0,1,.007-.046.624.624,0,0,0,0-.063V.626A.625.625,0,0,0,84.412,0H55.625A.625.625,0,0,0,55,.626V38.59a.625.625,0,0,0,.626.626H76.548l.046-.007h.015l.053-.013h.007l.05-.018h.007l.046-.021h.009l.04-.024.012-.008.036-.026.013-.01a.316.316,0,0,0,.04-.037h0l7.926-7.926h0c.013-.013.026-.027.038-.041ZM56.252,1.252H83.786V30.038a106.106,106.106,0,0,0-7.926,7.926H56.253ZM82.9,31.289l-5.79,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M196.842,81.252h12a.626.626,0,0,0,0-1.252h-12a.626.626,0,1,0,0,1.252Z",
    transform: "translate(-129.433 -73.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M121.437,64.408a.626.626,0,0,0,.885,0l3.338-3.338a.626.626,0,1,0-.885-.885l-2.9,2.9-.809-.809a.626.626,0,1,0-.885.885Z",
    transform: "translate(-59.579 -54.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M185,150.626a.625.625,0,0,0,.626.626h12.931a.626.626,0,0,0,0-1.252H185.626a.625.625,0,0,0-.626.625Z",
    transform: "translate(-119.153 -137.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M198.555,220H185.624a.626.626,0,0,0,0,1.252h12.931a.626.626,0,1,0,0-1.252Z",
    transform: "translate(-119.15 -201.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M198.555,290H185.624a.626.626,0,0,0,0,1.251h12.931a.626.626,0,0,0,0-1.252Z",
    transform: "translate(-119.15 -265.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M193.132,360h-7.507a.626.626,0,0,0,0,1.252h7.507a.626.626,0,0,0,0-1.252Z",
    transform: "translate(-119.15 -329.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M121.437,64.408a.626.626,0,0,0,.885,0l3.338-3.338a.626.626,0,1,0-.885-.885l-2.9,2.9-.809-.809a.626.626,0,1,0-.885.885Z",
    transform: "translate(-59.579 -49.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M121.437,64.408a.626.626,0,0,0,.885,0l3.338-3.338a.626.626,0,1,0-.885-.885l-2.9,2.9-.809-.809a.626.626,0,1,0-.885.885Z",
    transform: "translate(-59.579 -43.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M121.437,64.408a.626.626,0,0,0,.885,0l3.338-3.338a.626.626,0,1,0-.885-.885l-2.9,2.9-.809-.809a.626.626,0,1,0-.885.885Z",
    transform: "translate(-59.579 -38.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M121.437,64.408a.626.626,0,0,0,.885,0l3.338-3.338a.626.626,0,1,0-.885-.885l-2.9,2.9-.809-.809a.626.626,0,1,0-.885.885Z",
    transform: "translate(-59.579 -32.588)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishTest);
export default __webpack_public_path__ + "static/media/publish-test.318475b6b132abdb93a44c6c5eb858e7.svg";
export { ForwardRef as ReactComponent };